module.exports = function _pipe(f, g) {
  return function() {
    return g.call(this, f.apply(this, arguments));
  };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_pipe.js
// module id = 291
// module chunks = 1 2 3 4 5 6 7 8 9